require('./bootstrap')

// Import function
import Vue from 'vue'
import inView from 'in-view'
import testimonials from './data/testimonials'
import homeFaqs from './data/home-faqs'
import PhoneLink from './components/PhoneLink.vue'
import store from './store'
import ActionCard from './components/ActionCard.vue'
import { Carousel, Slide } from 'vue-carousel'

import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyC1o5ybaE9jncRcFRjW5o52zubisAg3HJU',
        libraries: 'places' // This is required if you use the Autocomplete plugin
        // OR: libraries: 'places,drawing'
    }
})

Vue.component('action-card', ActionCard)

import 'es6-promise/auto'

var standalone = window.navigator.standalone,
    userAgent = window.navigator.userAgent.toLowerCase(),
    safari = /safari/.test( userAgent ),
    ios = /iphone|ipod|ipad/.test( userAgent );

const mobileWidth = 900

const app = new Vue({
    el: '#app',
    components: {
        PhoneLink,
        carousel: Carousel,
        slide: Slide
    },
    store,
    data: {
        address: "",
        activeFaqSection: 'about',
        testimonials,
        homeFaqs,
        dealerModalVisible: false,
        slideout: {
            open: false
        },
        timer: 0,
        header: {
            transparent: true,
            lightText: false,
            hasAssessmentButton: false,
        },
        eventsFired: {
            home25: false,
            home50: false,
            home75: false,
            home100: false,
        }
    },
    computed: {

        activeTestimonial() {
            return this.testimonials.filter(t => t.active)[0]
        },

    },
    methods: {

        getAddressData(data) {
            let address = data.formatted_address
            this.address = address
        },

        toggleFaq(index) {
            this.homeFaqs[index].visible = !this.homeFaqs[index].visible
        },

        scrollToContent() {
            document.getElementById('contentToScrollTo').scrollIntoView({
                behavior: 'smooth'
            })
        },

        showTestimonial(id) {
            let ts = [...this.testimonials]
            this.testimonials = ts.map(t => {
                t.active = t.id === id
                return t
            })
        },

        scrollToAnchor(id) {
            let el = document.getElementById(id)
            let offset = el.offsetTop
            window.scroll({
                top: offset,
                left: 0,
                behavior: 'smooth'
            })
        },

        toggleSlideout() {
            this.slideout.open = !this.slideout.open
        },

        closeSlideout() {
            this.slideout.open = false
        },

        showDealerModal() {
            this.dealerModalVisible = true
        },

        hideDealerModal() {
            this.dealerModalVisible = false
        },

        startTimer() {
            setInterval(() => this.timer += 1, 1000)
        },

        goToAssessment(location, event) {
            event.preventDefault()

            let timerData = {
                location
            }
            
            // mixpanel.track("startedApp", timerData)
            mixpanel.people.set(timerData)

            let url = '/assessment'

            if (this.address) {
                url = url + '?address=' + this.address
            }

            window.location = url
        },

        watchForButton() {
            // inView('.heroButton')
            //     .on('enter', () => {
            //     if (!window.location.pathname.includes('why-adt')) {
            //         this.header.transparent = true
            //         if (window.location.pathname !== '/') {
            //             this.header.lightText = true
            //         }
            //     }
            // })
            // .on('exit', () => {
            //     this.header.transparent = false
            //     this.header.lightText = false
            // })
        }
    },
    mounted() {
        // HOMEPAGE
        if (window.location.pathname === '/') {
            this.startTimer()
            inView('.home-adt').on('enter', () => {
                if (!this.eventsFired.home25) {
                    mixpanel.track('home_25%_viewed')
                    this.eventsFired.home25 = true
                }
            })
            inView('.home-betterWay').on('enter', () => { 
                if (!this.eventsFired.home50) {
                    mixpanel.track('home_50%_viewed')
                    this.eventsFired.home50 = true
                }
            })
            inView('.home-quote').on('enter', () => { 
                if (!this.eventsFired.home75) {
                    mixpanel.track('home_75%_viewed')
                    this.eventsFired.home75 = true
                }
            })
            inView('.home-recentResources').on('enter', () => { 
                if (!this.eventsFired.home100) {
                    mixpanel.track('home_100%_viewed')
                    this.eventsFired.home100 = true
                }
            })
        }

        window.onscroll = (e) => {
            const offset = window.pageYOffset
            if (offset > 10) {
                this.header.transparent = false
                this.header.lightText = false
                this.header.hasAssessmentButton = true
            } else {
                this.header.transparent = true
                this.header.hasAssessmentButton = false
                // this.header.lightText = false
            }
        }

        // FAQ Page
        if (window.location.pathname.includes('faq')) {
            let section = document.querySelectorAll('.faqSection')
            let sections = {}
            let i = 0
            let that = this

            Array.prototype.forEach.call(section, function(e) {
                sections[e.id] = e.offsetTop
            })

            window.onscroll = function(e) {
                var scrollPosition =
                    document.documentElement.scrollTop ||
                    document.body.scrollTop

                for (i in sections) {
                    if (sections[i] <= scrollPosition) {
                        that.activeFaqSection = i
                    }
                }
            }
        }
    }
})

window.app = app

// burglar, dad, mail, snow, window smash, fire
